@if(isVisible()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6">
    <!-- Close button -->
    <button aria-label="Close" class="absolute top-2 right-2 text-gray-400 hover:text-gray-700" (click)="onCancel()">
      ✕
    </button>

    <!-- Icon -->
    <div class="flex justify-center mb-4">
      @if (icon() === 'signout') {
      <svg class="w-12 h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 12h12m-3-3 3 3-3 3" />
      </svg>
      } @else {
      <svg class="w-12 h-12 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2
             2 0 002 2h8a2 2 0 002-2V6a1
             1 0 100-2h-3.382l-.724-1.447A1
             1 0 0011 2H9zM7 8a1 1 0 012
             0v6a1 1 0 11-2
             0V8zm5-1a1 1 0
             00-1 1v6a1 1
             0 102 0V8a1
             1 0 00-1-1z" clip-rule="evenodd" />
      </svg>
      }
    </div>

    <!-- Message -->
    <p class="text-center text-gray-700 mb-6" [innerHTML]="message()"></p>

    <!-- Actions -->
    <div class="flex justify-center space-x-4">
      <button
        class="py-2 px-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
        (click)="onCancel()" [disabled]="isLoading()">
        Cancel
      </button>

      <button [disabled]="isLoading()"
        class="py-2 px-3 text-sm font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-500 dark:hover:bg-red-600 dark:focus:ring-red-900 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="onConfirm()">
        {{ isLoading() ? loadingLabel() : confirmLabel() }}
      </button>


    </div>
  </div>
</div>
}
